import CloseIcon from 'components/icons/CloseIcon';
import React from 'react';
import { toast as hotToast, useToaster } from 'react-hot-toast';
import { v4 } from 'uuid';

const CSS = require('./Toast.module.scss');

type CustomToastProps = {
  text: string;
  icon?: JSX.Element | string | null;
  toastId?: string;
  onClick?: () => void;
  variant?: 'default' | 'error' | 'success';
};

type ToastProps = CustomToastProps & {
  position?: 'top-center' | 'bottom-center';
};

const CustomToast = ({
  toastId,
  onClick,
  text,
  icon,
  variant,
}: CustomToastProps) => {
  const toaster = useToaster();
  const handleToastClick = () => onClick?.();
  const handleClose = () => {
    toaster.handlers.endPause();
    hotToast.remove(toastId);
  };
  const isClickable = typeof onClick === 'function' && onClick.length === 0;
  const ContentComponent = isClickable ? 'button' : 'div';
  return (
    <div className={CSS.ToastWrapper} data-variant={variant}>
      <ContentComponent onClick={handleToastClick} className={CSS.ToastButton}>
        <div className={CSS.Icon}>{icon}</div>
        <div className={CSS.Text}>{text}</div>
      </ContentComponent>
      <button className={CSS.CloseButton} onClick={handleClose}>
        <CloseIcon width={8} height={8} />
      </button>
    </div>
  );
};

const toast = ({
  text,
  icon = null,
  toastId = v4(),
  position = 'bottom-center',
  onClick,
  variant = 'default',
}: ToastProps) => {
  hotToast.custom(
    (t) => {
      return (
        <CustomToast
          toastId={t.id}
          onClick={onClick}
          icon={icon}
          text={text}
          variant={variant}
        />
      );
    },
    {
      id: toastId,
      position,
    },
  );
};
export default toast;
